import React from "react";
import FooterLogoGray from "../assets/Innaxys Logo-Grey.svg";
import { FaLinkedin } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useLanguage } from "../config/LanguageContext"; // Assuming this context is set up for translations

function Footer() {
  const { currentLanguage } = useLanguage();

  const productsFooterData = [
    {
      name: {
        en: "TRAM - Training Records & Asset Management Solution",
        fr: "TRAM - Solution de gestion des dossiers de formation et des actifs",
        de: "TRAM - Lösung zur Verwaltung von Trainingsunterlagen und Vermögenswerten",
        es: "TRAM - Solución de gestión de registros de formación y activos",
      },
      path: "/tram",
    },
    {
      name: {
        en: "DEAMS - Digital Evidence & Asset Management Solution",
        fr: "DEAMS - Solution de gestion des preuves numériques et des actifs",
        de: "DEAMS - Lösung zur Verwaltung digitaler Beweise und Vermögenswerte",
        es: "DEAMS - Solución de gestión de pruebas digitales y activos",
      },
      path: "/deams",
    },
    {
      name: {
        en: "DyTASK - GIS for Policing, with demand prediction and effective patrol and tasking management",
        fr: "DyTASK - SIG pour la police, avec prédiction de la demande et gestion efficace des patrouilles et des missions",
        de: "DyTASK - GIS für die Polizei mit Nachfrageprognose und effektiver Patrouillen- und Aufgabenverwaltung",
        es: "DyTASK - SIG para la policía, con predicción de la demanda y gestión eficaz de patrullas y tareas",
      },
      path: "/dytask",
    },
  ];

  const industriesFooterData = [
    {
      name: {
        en: "Police",
        fr: "Police",
        de: "Polizei",
        es: "Policía",
      },
      path: "/police",
    },
    {
      name: {
        en: "Fire & Rescue",
        fr: "Pompiers et secours",
        de: "Feuerwehr und Rettung",
        es: "Bomberos y rescate",
      },
      path: "/fire",
    },
    {
      name: {
        en: "Government",
        fr: "Gouvernement",
        de: "Regierung",
        es: "Gobierno",
      },
      path: "/government",
    },
    {
      name: {
        en: "Education",
        fr: "Éducation",
        de: "Bildung",
        es: "Educación",
      },
      path: "/education",
    },
    {
      name: {
        en: "Aviation",
        fr: "Aviation",
        de: "Luftfahrt",
        es: "Aviación",
      },
      path: "/aviation",
    },
  ];

  const companyFooterData = [
    {
      name: {
        en: "About",
        fr: "À propos",
        de: "Über uns",
        es: "Acerca de",
      },
      path: "/about",
    },
    {
      name: {
        en: "Resources",
        fr: "Ressources",
        de: "Ressourcen",
        es: "Recursos",
      },
      path: "/resources",
    },
    {
      name: {
        en: "Join",
        fr: "Rejoindre",
        de: "Beitreten",
        es: "Unirse",
      },
      path: "/careers",
    },
    {
      name: {
        en: "Contact",
        fr: "Contact",
        de: "Kontakt",
        es: "Contacto",
      },
      path: "/contact",
    },
  ];

  return (
    <section className="footer-wrapper">
      <div className="footer-options-wrapper">
        <div className="innaxys-footer-options">
          <figure className="innaxys-footer-logo">
            <img className="footer-logo" src={FooterLogoGray} alt="Footer Logo" />
          </figure>
          <p>53 Wilmot Street</p>
          <p>Heanor</p>
          <p>Derbyshire, DE75 7EF</p>
          <p>United Kingdom</p>
          <p className="footer-text-divider">+44 1773 765 350</p>
          <p>info@innaxys.com</p>
        </div>
        <div className="footer-options-right">
          <div className="footer-choices">
            <p className="footer-header">
              {
                {
                  en: "Solutions",
                  fr: "Solutions",
                  de: "Lösungen",
                  es: "Soluciones",
                }[currentLanguage]
              }
            </p>
            <ul>
              {productsFooterData.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>
                    {item.name[currentLanguage] || item.name.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-choices">
            <p className="footer-header">
              {
                {
                  en: "Industries",
                  fr: "Industries",
                  de: "Branchen",
                  es: "Industrias",
                }[currentLanguage]
              }
            </p>
            <ul>
              {industriesFooterData.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>
                    {item.name[currentLanguage] || item.name.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="footer-choices">
            <p className="footer-header">
              {
                {
                  en: "Company",
                  fr: "Compagnie",
                  de: "Unternehmen",
                  es: "Compañía",
                }[currentLanguage]
              }
            </p>
            <ul className="footer-list-items">
              {companyFooterData.map((item, index) => (
                <li key={index}>
                  <Link to={item.path}>
                    {item.name[currentLanguage] || item.name.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-extra">
        <div className="footer-socials">
          <Link to="https://www.linkedin.com/company/innaxys-ltd/">
            <FaLinkedin className="social-icons" size={24} />
          </Link>
        </div>
        <span className="footer-terms">
          <span className="footer-term-no-access">2025 Innaxys ©</span>
          <div className="footer-divider"></div>
          <Link to="/privacypolicy" className="footer-term">
            {
              {
                en: "Privacy Statement & Terms",
                fr: "Déclaration de confidentialité et conditions",
                de: "Datenschutzerklärung & Nutzungsbedingungen",
                es: "Declaración de privacidad y términos",
              }[currentLanguage]
            }
          </Link>
        </span>
      </div>
    </section>
  );
}

export default Footer;
